<template>
  <div class="mt-component-form">
    <vs-row class="my-4 center-flex">
      <h5><i class="dot"></i>{{ title }}</h5>
      <div class="ml-auto">
        <vs-button
          v-if="!isPrint"
          class=""
          color="secondary"
          type="border"
          @click="handleAddRow"
        >{{ $t('항목추가') }}</vs-button
        >
        <vs-button
          v-if="!isPrint"
          class="ml-4"
          color="secondary"
          @click="handleRemoveRow"
        >{{ $t('선택삭제') }}</vs-button
        >
      </div>
    </vs-row>

    <div class="grid row-header" style="grid-template-columns: 80px 240fr 340fr 185fr 185fr 120fr 185fr 260fr">
      <div class="col-span-1 row-header__item">
        <vs-checkbox
          v-model="equipAllCheck"
          @change="changeAllCheck"
        ></vs-checkbox>
      </div>
      <div class="row-header__item">{{ $t('주요일정') }}</div>
      <div class="row-header__item">{{ $t('시간') }}</div>
      <div class="row-header__item">{{ $t('소속명(부서명)') }}</div>
      <div class="row-header__item">{{ $t('직급/직책') }}</div>
      <div class="row-header__item">{{ $t('담당자') }}</div>
      <div class="row-header__item">{{ $t('연락처') }}</div>
      <div class="row-header__item">{{ $t('내용') }}</div>
    </div>
    <!-- rows -->
    <div
      class="grid row-content" style="grid-template-columns: 80px 240fr 340fr 185fr 185fr 120fr 185fr 260fr"
      v-for="(rows, indexRows) in targetList"
      :key="indexRows"
    >
      <div class="none-border-center">
        <vs-checkbox v-if="!isPrint" v-model="rows.is_checked"></vs-checkbox>
      </div>

      <!-- 주요일정 -->
      <div class="item-area p-1">
        <div v-if="isPrint">
          <span class="print-input ">{{ rows.title }}</span>
          <div class="w-full grid mt-2" style="grid-template-columns: auto 1fr; align-items: center; justify-content: center;">
            <i class="dot color0 ml-2 mr-2" :class="{
              'color1': rows.target === '안전보건총괄부서',
              'color2': rows.target === '부서',
              'color3': rows.target === '기타',
            }"></i>
            <span class="print-input">{{ rows.target }}</span>
          </div>
        </div>
        <div>
          <ml-input class="w-full " v-model="rows.title" placeholder="제목"/>
          <div class="w-full grid mt-2" style="grid-template-columns: auto 1fr; align-items: center; justify-content: center;">
            <i class="dot color0 ml-2 mr-2" :class="{
              'color1': rows.tag === '안전보건총괄부서',
              'color2': rows.tag === '부서',
              'color3': rows.tag === '기타',
            }"></i>
            <vs-select
              class="w-full"
              autocomplete
              v-model="rows.tag"
              placeholder="라벨"
            >
              <vs-select-item text="안전보건총괄부서" value="안전보건총괄부서" />
              <vs-select-item text="부서" value="부서" />
              <vs-select-item text="기타" value="기타" />
            </vs-select>
          </div>
        </div>


      </div>

      <!--시간 -->
      <div class="item-area p-1">
        <div v-if="!isPrint" class="grid" style="grid-template-columns: 1fr auto 1fr">
          <time-selector class="w-full" v-model="rows.startTime"/>
          <span class="mx-2">~</span>
          <time-selector class="w-full" v-model="rows.endTime"/>
        </div>
        <span v-else class="print-input">{{ rows.startTime }} ~ {{ rows.endTime }}</span>
      </div>

      <!-- 소속명(부서명) -->
      <div class="item-area p-1">
        <ml-input v-if="!isPrint" class="w-full " v-model="rows.className" />
        <span v-else class="print-input">{{ rows.className }}</span>
      </div>

      <!-- 직급/직책 -->
      <div class="item-area p-1">
        <ml-input
          v-if="!isPrint"
          rows="1"
          v-model="rows.rank"
          class="w-full flex-1"

        />
        <span v-else class="print-input">{{ rows.rank }}</span>
      </div>

      <!-- 담당자 -->
      <div class="item-area p-1">
        <ml-input
          v-if="!isPrint"
          rows="1"
          v-model="rows.manager"
          class="w-full flex-1"

        />
        <span v-else class="print-input">{{ rows.manager }}</span>
      </div>

      <!-- 연락처 -->
      <div class="item-area p-1">
        <ml-input
          v-if="!isPrint"
          rows="1"
          v-model="rows.phone"
          class="w-full flex-1"

        />
        <span v-else class="print-input">{{ rows.phone }}</span>
      </div>

      <!-- 내용 -->
      <div class="item-area p-1">
        <ml-textarea
          v-if="!isPrint"
          rows="4"
          v-model="rows.note"
          class="w-full flex-1 "

        />
        <span v-else class="print-textarea">{{ rows.note }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from '@/components/selector/DateSelector.vue'
import TimeSelector from '@/components/selector/TimeSelector.vue'

export default {
  name: 'ScheduleEditor',
  components: {
    TimeSelector,
    DateSelector},
  props: {
    title: String,
    value: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        if (value) {
          this.targetList = value
        } else {
          this.targetList = []
        }
      },
    },
  },
  methods: {
    // 항목추가
    handleAddRow () {
      this.targetList.push({
        is_checked: this.equipAllCheck,
        title: '',
        tag: '',
        startTime: '',
        endTime: '',
        className: '',
        rank: '',
        manager: '',
        phone: '',
        note: '',
      })
      this.updateList()
    },
    // 선택삭제
    handleRemoveRow () {
      for (let i = 0; i < this.targetList.length; i++) {
        if (this.targetList[i].is_checked) {
          this.targetList.remove(this.targetList[i])
          i = -1
        }
      }

      this.equipAllCheck = false
      this.updateList()
    },
    // 일괄 체크
    changeAllCheck () {
      for (const data of this.targetList) {
        data.is_checked = this.equipAllCheck
      }
    },
    // update
    updateList () {
      this.$emit('input', this.targetList)
    }
  },
  data () {
    return {
      equipAllCheck: false,
      targetList: [],
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  /*margin-left: 15px;*/
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border-top: $border;
  border-bottom: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dot {
  &.color0 { background-color: #cdcdcd; }
  &.color1 { background-color: rgba(126, 114, 242, 0.8); }
  &.color2 { background-color: #FFB976; }
  &.color3 { background-color: #9CA0A4; }
}
</style>
